<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="IntercomViewing" v-show="!isEditing">
              <div class="form-group col-md-5">
                <p style="font-size:35px">{{intercom.name}}</p>
                <br>
                <button v-on:click="edit" v-if="org['curOrg']['role'] == 99" type="button" class="btn  btn-default form-group">Edit</button>
              </div>
            </div>
            <!--Editing-->
            <div class="IntercomEditing col-md-5"  v-if="org['curOrg']['role'] == 99" v-show="isEditing">
              <form-text styler="font-size:35px" ref="name" label="Name" name="email" v-model="intercomEdit.name" validation="required"></form-text>
              <br>
              <div class="form-group">
                <button v-on:click="cancelEdit" type="button" class="btn  btn-default">Cancel</button>
                <button v-on:click="submitEdit" type="button" class="btn  btn-success">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
      </div><!-- /.col-md-3 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../../elements/Form/FormText'
import database from '../../../webmaster/Database/database'
import store from '../../../webmaster/Store/vuex'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'editintercom',
  components:{
    'form-text':FormText,
  },
  data () {
    return {
      org: store.state.usermain,
      intercom:{},
      intercomEdit:{},
      isEditing: false,
    }
  },
  created:function(){
    this.fetchIntercom()
  },
  methods: {
    edit: function(){
      this.isEditing = true;
    },
    cancelEdit: function(){
      this.isEditing = false;
    },
    fetchIntercom: function(){
      this.$bindAsObject('intercom', database.getRef('/orgs/' + this.$store.state.usermain.curOrg.id + '/devices/' + this.$route.params.id), null, function(){
        this.intercomEdit = Object.assign({}, this.intercomEdit, this.intercom);
      });
    },
    submitEdit: function(){
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        this.updateIntercom(database.getDb().ref(), self.$store.state.usermain.curOrg.id, self.intercomEdit['.key'], self.intercomEdit.name).then(_ => {
          this.intercom = Object.assign({}, this.intercom, this.intercomEdit);
          self.isEditing = false;
        }).catch(err => {
          console.log(err)
        });
      }, () => {});
    },
    updateIntercom: function(rootRef, orgId, deviceId, name){
      let updates = {}

      updates['/orgs/' + orgId + '/devices/' + deviceId + '/name'] = name
      updates['/orgs/' + orgId + '/wire/users/' + deviceId + '/name'] = name;
      
      var intercomChatsRef = '/orgs/' + orgId + '/wire/users/' + deviceId + '/chats';

      return database.getRef(intercomChatsRef).once('value').then(chatsSnapshot => {
        if (chatsSnapshot.val() != null && chatsSnapshot.val() != undefined) {
          return Object.keys(chatsSnapshot.val());
        }
        return [];
      }).then(chatIds => {
        chatIds.forEach(function (chatId) {
          updates['/orgs/' + orgId + '/wire/chats/' + chatId + '/members/' + deviceId] = name;
        });

        return rootRef.update(updates);
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// EditIntercom.vue?6d65c9b8